import PropTypes from 'prop-types';

export default {
    colors: PropTypes.shape({
        backgroundColor: PropTypes.string,
        color: PropTypes.string,
        itemOdd: PropTypes.shape({
            backgroundColor: PropTypes.string,
            borderColor: PropTypes.string
        }),
        itemEven: PropTypes.shape({
            backgroundColor: PropTypes.string,
            borderColor: PropTypes.string
        }),
        itemActive: PropTypes.shape({
            background: PropTypes.string,
            borderColor: PropTypes.string,
            color: PropTypes.string
        }),
        itemNext: PropTypes.shape({
            borderColor: PropTypes.string
        }),
        extra: PropTypes.shape({
            label: PropTypes.shape({
                color: PropTypes.string
            }),
            value: PropTypes.shape({
                color: PropTypes.string
            }),
            item: PropTypes.shape({
                borderColor: PropTypes.string
            })
        }),
        extraActive: PropTypes.shape({
            label: PropTypes.shape({
                color: PropTypes.string
            }),
            value: PropTypes.shape({
                color: PropTypes.string
            }),
            item: PropTypes.shape({
                borderColor: PropTypes.string
            })
        })
    }).isRequired
};



// WEBPACK FOOTER //
// ./src/views/Home/table/TableStartList/default-prop-types.js